import { useQuery } from "@tanstack/react-query";
import { QueryParamProps } from "../@types";
import api from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";

export const useNetworkThreatIntelPayloads = (
  url: string,
  queryParams: QueryParamProps
) => {
  const { data: payloadsData, isLoading } = useQuery({
    queryKey: ["payloads", url, queryParams],
    queryFn: () =>
      api.getUrlPayloads({
        url,
        queryParams
      }),
    select: ({ data }) => data,
    enabled: Boolean(url),
    throwOnError: true,
    ...USEQUERY_DISABLE_REFETCH_OPTIONS
  });

  return { data: payloadsData, isLoading };
};
